import { Theme } from "@npco/zeller-design-system";
import * as Sentry from "@sentry/browser";

export function onRequestQueryEnd() {
	Sentry.getIsolationScope().clear();

	Theme.set(undefined);

	window._cancel = undefined;
	window._request = undefined;
	window._setRequest?.(undefined);
}
